import './MapCard.css';

function MapCard({ area, description, image, alt }) {
  return (
    <article className="map-card">
      <div className="map-card__image">
        <img src={image} alt={alt || area} />
      </div>
      <div className="map-card__content">
        <p>
          <span className="map-card__area">{area}</span>
          <span className="map-card__separator">：</span>
          {description}
        </p>
      </div>
    </article>
  );
}

export default MapCard;
